import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MessageNotificationService {

  private totalUnreadSubject = new BehaviorSubject<number>(0);

  setTotalUnread(count: number): void {
    if (count < 0) {
      count = 0;
    }
    this.totalUnreadSubject.next(count);
  }

  getTotalUnread(): Observable<number> {
    return this.totalUnreadSubject.asObservable();
  }
}


